import { UploadArchiveResult } from '@/core/domain/archive/Archive/Archive.types';
import { Upload, UploadFile } from 'antd';
import ImgCrop from 'antd-img-crop';
import 'antd/es/slider/style';
import { RcFile, UploadChangeParam } from 'antd/lib/upload';
import { UploadRequestOption } from 'rc-upload/lib/interface';
import { UploadCloud } from 'react-feather';
import AntdFeatherIcon from '../../AntdFeatherIcon';

interface CroperUploadInterface {
  customRequest: ({
    onSuccess,
    onError,
    file,
  }: UploadRequestOption) => Promise<void>;
  maxFileCount: number;
  handleRemove: (file: UploadFile<UploadArchiveResult>) => Promise<void>;
  handlePreview: (file: UploadFile<UploadArchiveResult>) => Promise<void>;
  label?: string;
  fileList?: RcFile[];
  id?: string;
  onChange?: (info: UploadChangeParam<UploadFile<UploadArchiveResult>>) => void;
}

const CroperUpload: React.FC<CroperUploadInterface> = ({
  customRequest,
  maxFileCount,
  handlePreview,
  handleRemove,
  label,
  ...params
}) => (
  <ImgCrop
    modalTitle="Editar imagem"
    aspect={1}
    quality={0.1}
    minZoom={0.5}
    maxZoom={3}
    cropperProps={{
      style: { containerStyle: { height: 400 } },
      mediaProps: {},
      restrictPosition: false,
      cropSize: { height: 200, width: 200 },
      zoomSpeed: 0.5,
    }}
  >
    <Upload
      listType="picture-card"
      customRequest={customRequest}
      maxCount={maxFileCount}
      onPreview={handlePreview}
      onRemove={handleRemove}
      {...params}
    >
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        <AntdFeatherIcon icon={<UploadCloud />} />
        <div>{label || 'Upload'}</div>
      </div>
    </Upload>
  </ImgCrop>
);

export default CroperUpload;
